const nav = {
  id: {
    home: "Beranda",
    archive: "Arsip",
    lang: "ID",
    dark: "Gelap",
    light: "Terang",
    logout: "Keluar",
  },
  en: {
    home: "Home",
    archive: "Archive",
    lang: "EN",
    dark: "Dark",
    light: "Light",
    logout: "LogOut",
  },
};

const card = {
  id: {
    archive: "Arsip",
    unarchive: "Batal Arsip",
  },
  en: {
    archive: "Archive",
    unarchive: "Unarchive",
  },
};

const input = {
  id: {
    titlePlaceholder: "Masukkan judul..",
    bodyPlaceholder: "Masukkan konten..",
    submit: "Tambah",
  },
  en: {
    titlePlaceholder: "Input title..",
    bodyPlaceholder: "Input content..",
    submit: "Add",
  },
};

const search = {
  id: {
    placeholder: "Cari catatan..",
  },
  en: {
    placeholder: "Search note..",
  },
};

const login = {
  id: {
    title: "Masuk",
    email: "Surel",
    password: "Kata Sandi",
    emailPlaceholder: "Masukkan surel..",
    passwordPlaceholder: "Masukkan kata sandi..",
    question: "Belum punya akun?",
    register: "Daftar",
    submit: "Masuk",
  },
  en: {
    title: "Login",
    email: "Email",
    password: "Password",
    emailPlaceholder: "Input email..",
    passwordPlaceholder: "Input password..",
    question: "Don't have an account?",
    register: "Register",
    submit: "Login",
  },
};

const register = {
  id: {
    title: "Daftar",
    name: "Nama",
    email: "Surel",
    password: "Kata Sandi",
    confirmPassword: "Konfirmasi kata sandi",
    namePlaceholder: "Masukkan nama..",
    emailPlaceholder: "Masukkan surel..",
    passwordPlaceholder: "Masukkan kata sandi..",
    confirmPasswordPlaceholder: "Konfirmasi kata sandi..",
    alert: "Kata sandi tidak sama",
    question: "Sudah punya akun?",
    login: "Masuk",
    submit: "Daftar",
  },
  en: {
    title: "Register",
    name: "Name",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm password",
    namePlaceholder: "Input name..",
    emailPlaceholder: "Input email..",
    passwordPlaceholder: "Input password..",
    confirmPasswordPlaceholder: "Confirm password..",
    alert: "Passwords do not match",
    question: "Already have an account?",
    login: "Login",
    submit: "Register",
  },
};

const noteNotFound = {
  id: {
    message: "Belum ada catatan",
  },
  en: {
    message: "Note not found",
  },
};

const pageNotFound = {
  id: {
    message: "Halaman tidak ditemukan",
  },
  en: {
    message: "Page not found",
  },
};

export const content = {
  nav,
  card,
  input,
  search,
  login,
  register,
  noteNotFound,
  pageNotFound,
};
